import Logo from "@/components/feature/Logo";

export default function Footer() {
  return (
    <footer className="bg-texas-navy pt-12 pb-6 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex justify-center mb-8">
          <Logo variant="light" size="lg" />
        </div>
        <hr className="border-white/10 mb-6" />
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-10 mb-6 text-sm text-white/60">
          <a
            href="https://maps.google.com/?q=5900+Balcones+Dr+Suite+30942+Austin+TX+78731"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="hover:text-white transition-colors cursor-pointer text-center"
          >
            5900 Balcones Dr, Suite 30942, Austin, TX 78731
          </a>
          <a
            href="mailto:contact@mytexascsa.com"
            className="hover:text-white transition-colors cursor-pointer"
          >
            contact@mytexascsa.com
          </a>
          <a
            href="tel:210-448-6057"
            className="hover:text-white transition-colors cursor-pointer"
          >
            210-448-6057
          </a>
        </div>
        <div className="flex items-center justify-center gap-6 mb-6 text-sm">
          <a
            href="#about"
            className="text-white/50 hover:text-texas-red transition-colors cursor-pointer whitespace-nowrap"
          >
            About
          </a>
          <a
            href="#products"
            className="text-white/50 hover:text-texas-red transition-colors cursor-pointer whitespace-nowrap"
          >
            Services
          </a>
          <a
            href="#contact"
            className="text-white/50 hover:text-texas-red transition-colors cursor-pointer whitespace-nowrap"
          >
            Contact
          </a>
        </div>
        <p className="text-center text-xs text-white/30">
          &copy; 2026 Texas Consultancy and Sales Agency. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
